import API_ENDPOINT from "../../api/api_endpoint";
import { postApi } from "../../api/api_methods";
import NotificationComponent from "../../components/alert-component/component";
import { initContactForm } from "./index.slice";


export function sendMailContactAPI(payload, callback) {
    return async (dispatch) => {
        postApi(API_ENDPOINT.SEND_MAIL + '?option=contactForm', payload)
            .then((res) => {
                dispatch(initContactForm())
                NotificationComponent(false,
                    "success",
                    "Opération terminée avec succès !",
                )
            })
            .catch((err) => {
                NotificationComponent(false,
                    "error",
                    "Erreur d'envoi du formulaire",
                )
            });
    };
}